import { LeasingSeasonListItem } from '../types/leasingSeason.types'

export function sortSeasonsByStartDate(
    seasons: LeasingSeasonListItem[],
): LeasingSeasonListItem[] {
    return [...seasons].sort(
        (a, b) =>
            new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
    )
}

export function getPriorSeason(
    seasons: LeasingSeasonListItem[],
    seasonId: number,
): LeasingSeasonListItem | null {
    const sorted = sortSeasonsByStartDate(seasons)
    const index = sorted.findIndex((s) => s.id === seasonId)
    if (index <= 0) return null
    return sorted[index - 1]
}

export function getPriorSeasonPercentLeased(
    seasons: LeasingSeasonListItem[],
    seasonId: number,
    percentBySeasonId: Map<number, number>,
): number | null {
    const prior = getPriorSeason(seasons, seasonId)
    if (!prior) return null
    const percent = percentBySeasonId.get(prior.id)
    return percent != null ? percent : null
}
